<div class="themes-switcher"
     [nbPopover]="switcherListComponent"
     nbPopoverPlacement="bottom"
     [nbPopoverContext]="{popover: popover}">
  <i class="nb-drops"></i>
  <span *ngIf="showTitle">Themes</span>
</div>
